import getHeaders from '../helpers/headers'
import axios from 'axios'
import config from '../../constants/endpoints.js'

const {
  endpoints: {
    credentials: { credentialHeaders, credentialById, credentialByKey, linkExpireTime },
  },
} = config

/**
 * Obtain credentials headers in use by the company.
 * @param {String} params.provider Get specific provider
 */
const getCredentials = (params) => axios.get(credentialHeaders, { headers: getHeaders(true), params })

/**
 * Obtain credential in use by the company.
 * @param {String} params.provider Get specific provider
 */
const getCredentialsByKey = (params) =>
  axios.get(credentialByKey.replace(':type', params.type).replace(':key', params.key), {
    headers: getHeaders(true),
    params,
  })

/**
 * Create specific provider credentials.
 * @param {Object} data Data of credentials
 */
const createCredentials = (credential) =>
  axios.post(credentialByKey.replace(':key', credential.key).replace(':type', credential.type), { credential }, { headers: getHeaders(true) })

/**
 * Update specific provider credentials.
 * @param {Object} data Data of credentials
 */
const updateCredentials = (credential) =>
  axios.put(credentialById.replace(':key', credential.key).replace(':id', credential._id), { credential }, { headers: getHeaders(true) })

/**
 * Remove specific provider credentials.
 * @param {Object} data Data of credentials
 */
const deleteCredentials = (credential) =>
  axios.delete(credentialById.replace(':key', credential.key).replace(':id', credential._id), {
    headers: getHeaders(true),
  })

/**
 * Obtain LinkExpireTime
 */
const getLinkExpireTime = () => axios.get(linkExpireTime, { headers: getHeaders(true) })

/**
 * Create specific provider credentials.
 * @param {Object} data Data of credentials
 */
const postLinkExpireTime = (data) => axios.post(linkExpireTime, data, { headers: getHeaders(true) })

export default {
  updateCredentials,
  getCredentials,
  getCredentialsByKey,
  createCredentials,
  deleteCredentials,
  getLinkExpireTime,
  postLinkExpireTime
}
